import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CaretDown from '@material-ui/icons/KeyboardArrowDown';
import CaretUp from '@material-ui/icons/KeyboardArrowUp';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Refresh from '@material-ui/icons/Refresh';
import Sort from '@material-ui/icons/UnfoldMore';
import { formatPrice } from 'helpers/utils';

import {
  injectIntl,
  SearchComponent,
  Tooltip,
} from 'components';

const styles = () => ({
  button: {
    backgroundColor: '#818a91',
    borderRadius: 5,
  },
  harvestButton: {
    backgroundColor: '#f19b37',
    borderRadius: 5,
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  },
  harvestListBtn: {
    backgroundColor: '#f19b37',
    marginRight: 20,
  },
  harvestListBtnLabel: {
    color: '#fff',
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
  lightBtn: { paddingLeft: 0 },
  lightBtnLabel: { textTransform: 'none' },
  groupedListButton: {
    backgroundColor: '#9a601e',
    borderRadius: 5,
    marginRight: 10,
  },
  groupedListBtn: {
    border: '1px solid #9a601e',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  },
  packListButton: {
    backgroundColor: '#448fe4',
    borderRadius: 5,
    marginRight: 10,
  },
  packListBtn: {
    border: '1px solid #448fe4',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  },
  packListBtnLabel: {
    color: '#fff',
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
  pickListBtn: {
    border: '1px solid #818a91',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    marginRight: 10,
  },
  warehouseListBtn: {
    backgroundColor: '#ff6e0f',
    border: '1px solid #ff6e0f',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  },
  filterButton: {
    backgroundColor: '#FFFFFF',
    borderRadius: 5,
    marginRight: 10,
    marginBottom: 5,
  },
  filterButtonLabel: {
    color: '#4694EB',
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
});

class InvoiceListToolbar extends Component {
  static contextTypes = {
    isRestaurant: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isDistributor: PropTypes.bool,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    searchText: PropTypes.string,
    showHarvest: PropTypes.bool.isRequired,
    showGroupedList: PropTypes.bool.isRequired,
    showPickPack: PropTypes.bool.isRequired,
    showWarehouseList: PropTypes.bool.isRequired,
    showLabels: PropTypes.bool.isRequired,
    sortDirection: PropTypes.bool.isRequired,
    sortMethod: PropTypes.string.isRequired,

    cancelSearch: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    getPackList: PropTypes.func.isRequired,
    getPickList: PropTypes.func.isRequired,
    getWarehouseList: PropTypes.func.isRequired,
    reload: PropTypes.func.isRequired,
    search: PropTypes.func.isRequired,
    setStateForGroupedList: PropTypes.func.isRequired,
    setStateForHarvest: PropTypes.func.isRequired,
    setStateForPickPack: PropTypes.func.isRequired,
    setStateForWarehouse: PropTypes.func.isRequired,
    sortByCustomer: PropTypes.func.isRequired,
    sortByOrder: PropTypes.func.isRequired,
    setStateForInvoices: PropTypes.func.isRequired,
    setStateForLabels: PropTypes.func.isRequired,
    dailySalesPurchases: PropTypes.shape({}),
  };

  static defaultProps = {
    searchText: '',
    dailySalesPurchases: {}
  };

  showGroupedList = () => {
    const { getPackList, setStateForGroupedList } = this.props;
    getPackList();
    setStateForGroupedList();
  }

  showHarvestList = () => {
    const { getPackList, setStateForHarvest } = this.props;
    getPackList();
    setStateForHarvest();
  }

  showPickAndPackList = (isPack = false) => {
    const {
      getPackList,
      getPickList,
      setStateForPickPack,
    } = this.props;
    if (isPack) {
      getPackList();
    } else {
      getPickList();
    }
    setStateForPickPack(isPack);
  }

  showWarehouseList = () => {
    const { getWarehouseList, setStateForWarehouse } = this.props;
    getWarehouseList();
    setStateForWarehouse();
  }

  showInvoices = () => {
    const { setStateForInvoices } = this.props;
    setStateForInvoices();
  }

  showLabels = () => {
    const { setStateForLabels } = this.props;
    setStateForLabels();
  }

  render() {
    const {
      cancelSearch,
      classes,
      formatMessage,
      reload,
      search,
      searchText,
      showHarvest,
      showGroupedList,
      showPickPack,
      showWarehouseList,
      sortByCustomer,
      sortByOrder,
      sortDirection,
      sortMethod,
      showLabels,
      dailySalesPurchases,
    } = this.props;
    const {
      isFarmer,
      isRestaurant,
      isDistributor,
    } = this.context;
    let iconDirectionForOrder = <Sort />;
    let iconDirectionForCustomer = <Sort />;

    if (sortMethod === 'updatedAt') {
      iconDirectionForCustomer = <Sort />;
      iconDirectionForOrder = sortDirection ? <CaretUp /> : <CaretDown />;
    } else if (sortMethod === 'companyName') {
      iconDirectionForOrder = <Sort />;
      iconDirectionForCustomer = sortDirection ? <CaretUp /> : <CaretDown />;
    }

    return (
      <div>
        <SearchComponent
          cancelSearch={cancelSearch}
          placeholder={formatMessage('Invoices')}
          search={search}
          searchText={searchText}
        />
        { (isFarmer || isRestaurant || isDistributor) &&
        <div className="invoice-toolbar">
          <div className="invoice-actions-other">
            {
              showHarvest && 
              <Button
                classes={{
                  label: classes.filterButtonLabel,
                  root: classes.filterButton,
                }}
                onClick={this.showHarvestList}
                variant="contained"
              >
                {formatMessage('HARVEST LIST')}
              </Button>
            }
            {
              showPickPack &&
              <Button
                classes={{
                  label: classes.filterButtonLabel,
                  root: classes.filterButton,
                }}
                onClick={() => this.showPickAndPackList(true)}
                variant="contained"
              >
                {formatMessage('PACK LIST')}
              </Button>
            }
            {
              showGroupedList &&
              <Button
                classes={{
                  label: classes.filterButtonLabel,
                  root: classes.filterButton,
                }}
                onClick={() => this.showGroupedList()}
                variant="contained"
              >
                {formatMessage('GROUPED LIST')}
              </Button>
            }
            {
              !isFarmer && showPickPack &&
              <Button
                classes={{
                  label: classes.filterButtonLabel,
                  root: classes.filterButton,
                }}
                onClick={() => this.showPickAndPackList()}
                variant="contained"
              >
                {formatMessage('PICK LIST')}
              </Button>
            }
            {
              !isFarmer && showWarehouseList &&
              <Button
                classes={{
                  label: classes.filterButtonLabel,
                  root: classes.filterButton,
                }}
                onClick={() => this.showWarehouseList()}
                variant="contained"
              >
                {formatMessage('WAREHOUSE LIST')}
              </Button>
            }
            {
              showLabels && (
                <Button
                  className={"d-lg-up-none"}
                  classes={{
                    label: classes.filterButtonLabel,
                    root: classes.filterButton,
                  }}
                  style={{textTransform: 'uppercase'}}
                  onClick={() => this.showLabels()}
                  variant="contained"
                >
                  {formatMessage('labels')}
                </Button>
                )
            }
          </div>
          <div className={isDistributor ? "invoice-actions" :"invoice-actions d-md-down-none"} >
            <Button
              classes={{
                label: classes.lightBtnLabel,
                root: classes.lightBtn,
              }}
              onClick={sortByCustomer}
              variant="text"
            >
              {iconDirectionForCustomer}
              {isRestaurant ? formatMessage('Vendor') : formatMessage('Customer')}
            </Button>
            <Button
              classes={{
                label: classes.lightBtnLabel,
                root: classes.lightBtn,
              }}
              onClick={sortByOrder}
              variant="text"
            >
              {iconDirectionForOrder}
              {<span>Latest</span>}
            </Button>
            {!isRestaurant && (
                <div className="filter-options d-flex">
                  {isDistributor && (
                    <Button
                      classes={{
                        label: classes.filterButtonLabel,
                        root: classes.filterButton,
                      }}
                      onClick={() => this.showInvoices()}
                      variant="contained"
                    >
                      {formatMessage('Invoices')}
                    </Button>
                  )}
                  { showLabels && 
                    <Button
                    classes={{
                      label: classes.filterButtonLabel,
                      root: classes.filterButton,
                    }}
                    onClick={() => this.showLabels()}
                    variant="contained"
                  >
                    {formatMessage('Labels')}
                  </Button>
                  }
                  
                </div>
            )}
          </div>
        </div>
        }
      </div>
    );
  }
}

const wrappedInvoiceListToolbar = withStyles(styles)(injectIntl(InvoiceListToolbar));
wrappedInvoiceListToolbar.displayName = 'InvoiceListToolbar';

export default wrappedInvoiceListToolbar;
